import { Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

export const CustomizableText = styled(Text)`
  color: black;
  font-style: italic;
`;
